import React, { FC, forwardRef, Ref } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
import { Section } from '@/helpers/Section';
// styles
import { getStyles as getDfltStyles } from './styles.css';
import block from './block.json';

interface ForwardedSectionOneColumn
	extends React.ForwardRefExoticComponent<
			SectionOneColumnProps & React.RefAttributes<HTMLDivElement>
		>,
		BlockConfigs {}

/**
 * COMPONENT
 */
export const SectionOneColumn = forwardRef<
	HTMLDivElement,
	SectionOneColumnProps
>(
	(
		{
			anchor,
			className,
			uptitle,
			title,
			introduction,
			slug,
			variant: currentVariant = 'default',
			titleTag = 'h2',
			children,
			theme = {},
			getStyles = getDfltStyles,
		},
		ref
	) => {
		const { variant, blockTheme } = useThemeBlock(
			slug,
			theme,
			currentVariant
		);

		const trimmedSlug = slug.split('/');
		const modifierSlug = trimmedSlug[trimmedSlug.length - 1];

		const rootClass = cx(
			'supt-section supt-section--oneCol',
			`supt-section--${modifierSlug}`,
			getStyles(blockTheme),
			className
		);

		return (
			<Section
				id={anchor}
				className={rootClass}
				variant={variant}
				slug={slug}
				ref={ref}
			>
				<div className="supt-section__inner">
					{(uptitle || title || introduction) && (
						<div className="supt-section__headline">
							{uptitle && <Section.Uptitle text={uptitle} />}
							{title && (
								<Section.Title
									text={title}
									titleTag={titleTag}
								/>
							)}
							{introduction && (
								<Section.Introduction text={introduction} />
							)}
						</div>
					)}
					<div className="supt-section__content">{children}</div>
				</div>
			</Section>
		);
	}
) as ForwardedSectionOneColumn;

SectionOneColumn.slug = block.slug;
SectionOneColumn.title = block.title;
